import { render, staticRenderFns } from "./ECartaoResponsavel.vue?vue&type=template&id=745fafa0&scoped=true"
import script from "./ECartaoResponsavel.vue?vue&type=script&lang=js"
export * from "./ECartaoResponsavel.vue?vue&type=script&lang=js"
import style0 from "./ECartaoResponsavel.vue?vue&type=style&index=0&id=745fafa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745fafa0",
  null
  
)

export default component.exports